import { FigureTwicpics } from '@studiometa/ui';
import { isProd } from '../../config.js';

/**
 * Custom FigureTwicpics class
 */
export default class Figure extends FigureTwicpics {
  static config = {
    ...FigureTwicpics,
    options: {
      intersectionObserver: {
        type: Object,
        default: () => ({
          threshold: [0, 1],
          rootMargin: '400px 0px 400px 0px',
        }),
      },
    },
  };

  /**
   * Get domain
   * @returns {string}
   */
  get domain() {
    return this.$options.domain;
  }

  /**
   * No path in production, use the hostname otherwise.
   * @returns {string}
   */
  get path() {
    return isProd ? '' : window.location.hostname;
  }
}
